import { Cookie } from '@nuxt-common/util/app/utils/cookie';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $pinia } = nuxtApp;
  const isClientInjection = !!window.__NAVIGATION__ENV_PROPS__;

  function getContext() {
    const regionCode = Cookie.get('shippingCountry') || 'US';
    const currencyCode = Cookie.get('currency') || 'USD';
    const isDomestic = regionCode === 'US';
    const isInternational = !isDomestic;

    return {
      regionCode,
      currencyCode,
      isDomestic,
      isInternational,
    };
  }

  if (!isClientInjection) {
    if ($pinia.state.value.pageData.navigation.context.isInternational) {
      $pinia.state.value.pageData.navigation.context = {
        ...$pinia.state.value.pageData.navigation.context,
        ...getContext(),
      };
    }
    return;
  }

  const { brand, hostlink, assethost } = window.__NAVIGATION__ENV_PROPS__;

  $pinia.state.value.envProps = {
    brand,
    hostlink,
    assethost,
    isMcom: brand === 'mcom',
    isBcom: brand === 'bcom',
    isNavSSR: false,
  };

  $pinia.state.value.pageData = {
    navigation: {
      context: getContext(),
    },
    killswitches: { override: {} },
  };
});
